module.exports = __webpack_public_path__ + "static/img/qrdy.2861fae.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/qrdy.png
// module id = kT0t
// module chunks = 1